(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["deals"] && !Shopify.designMode) return;
  try {
    (() => {
    const SELECTOR = '[data-countdown-root]';

    function getRoots(scope) {
      if (!scope) return [];
      const roots = [];

      if (scope.matches && scope.matches(SELECTOR)) {
        roots.push(scope);
      }

      if (scope.querySelectorAll) {
        roots.push(...scope.querySelectorAll(SELECTOR));
      }

      return roots;
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function getDailyMidnightEnd(resetHour) {
      const now = new Date();
      const end = new Date(now);

      end.setHours(resetHour, 0, 0, 0);

      if (now.getTime() >= end.getTime()) {
        end.setDate(end.getDate() + 1);
      }

      return end.getTime();
    }

    function getRollingEnd(root) {
      const durationMs = Number(root.dataset.duration || 86400) * 1000;
      const storageKey = root.dataset.storageKey;
      const now = Date.now();

      if (!storageKey) return now + durationMs;

      try {
        const saved = Number(window.localStorage.getItem(storageKey));

        if (saved && saved > now) {
          return saved;
        }

        const next = now + durationMs;
        window.localStorage.setItem(storageKey, String(next));
        return next;
      } catch (error) {
        return now + durationMs;
      }
    }

    function renewRollingEnd(root) {
      const durationMs = Number(root.dataset.duration || 86400) * 1000;
      const storageKey = root.dataset.storageKey;
      const next = Date.now() + durationMs;

      if (storageKey) {
        try {
          window.localStorage.setItem(storageKey, String(next));
        } catch (error) {}
      }

      return next;
    }

    function getEndTime(root) {
      const mode = root.dataset.mode || 'daily_midnight';
      const resetHour = Number(root.dataset.resetHour || 0);

      if (mode === 'rolling_24h') {
        return getRollingEnd(root);
      }

      return getDailyMidnightEnd(resetHour);
    }

    function renewEndTime(root) {
      const mode = root.dataset.mode || 'daily_midnight';
      const resetHour = Number(root.dataset.resetHour || 0);

      if (mode === 'rolling_24h') {
        return renewRollingEnd(root);
      }

      return getDailyMidnightEnd(resetHour);
    }

    function destroy(root) {
      if (root.__dealTimerInterval) {
        clearInterval(root.__dealTimerInterval);
        root.__dealTimerInterval = null;
      }

      root.dataset.timerMounted = 'false';
    }

    function mount(root) {
      if (!root || root.dataset.timerMounted === 'true') return;

      const daysEl = root.querySelector('[data-days]');
      const hoursEl = root.querySelector('[data-hours]');
      const minutesEl = root.querySelector('[data-minutes]');
      const secondsEl = root.querySelector('[data-seconds]');

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      root.dataset.timerMounted = 'true';

      let endTime = getEndTime(root);

      const tick = () => {
        const now = Date.now();
        let remaining = endTime - now;

        if (remaining <= 0) {
          endTime = renewEndTime(root);
          remaining = endTime - now;
        }

        const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        daysEl.textContent = '00';
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      };

      tick();
      root.__dealTimerInterval = window.setInterval(tick, 1000);
    }

    function init(scope = document) {
      getRoots(scope).forEach((root) => {
        destroy(root);
        mount(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:block:select', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      getRoots(event.target).forEach(destroy);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
